import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { MaintenanceEventShortTermRentalService } from '../maintenance-event-shorttermrental.service';
import { MaintenanceEventShortTermRentalComponent } from '../maintenance-event-shorttermrental/maintenance-event-shorttermrental.component';
import { MaintenanceEventShortTermRental } from '../maintenance-event-shorttermrental';

@Component({
    selector: 'app-maintenance-event-shorttermrental-list',
    templateUrl: './maintenance-event-shorttermrental-list.component.html',
    styleUrls: ['./maintenance-event-shorttermrental-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class MaintenanceEventShortTermRentalListComponent implements OnInit {
	constructor(
		private maintenanceEventShortTermRentalService: MaintenanceEventShortTermRentalService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = maintenanceEventShortTermRentalService.statuses
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() maintenanceEventId: any;
	maintenanceEventShortTermRentals: any;
	maintenanceEventShortTermRental: MaintenanceEventShortTermRental;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'shortTermRentalId', header: 'Id', width: 'auto' },
		{ field: 'propertyCode', header: 'Property', width: 'auto' },
		{ field: 'opsNote', header: 'Operational Note', width: 'auto' },
		{ field: 'createDate', header: 'Date Created', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.shortTermRentalId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-maintenanceEventShortTermRental-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.maintenanceEventId)
				{
					// show only shortTermRentals that are assigned to this propertyCodeFilter
					let propertyIdFilter = { 'maintenanceEventId': { 'value': JSON.stringify(this.maintenanceEventId), 'matchMode': 'in' } };
					Object.assign(event.filters, propertyIdFilter);
				}

			const pageNumber = Math.round(event.first / event.rows);
			this.maintenanceEventShortTermRentalService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.maintenanceEventShortTermRentals = res.data.maintenanceEventShortTermRentals;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.maintenanceEventShortTermRentals = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(maintenanceEventShortTermRental: MaintenanceEventShortTermRental) {
		try {
			this.formLoading = true;
			this.maintenanceEventShortTermRentalService.update(maintenanceEventShortTermRental)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.maintenanceEventShortTermRentals.map((maintenanceEventShortTermRental, i) => {
							if (maintenanceEventShortTermRental.shortTermRentalId === res.data.maintenanceEventShortTermRental.shortTermRentalId) {
								this.maintenanceEventShortTermRentals[i] = res.data.maintenanceEventShortTermRental;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(maintenanceEventShortTermRental: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(maintenanceEventShortTermRental));

			this.formLoading = true;
			this.maintenanceEventShortTermRentalService.delete(maintenanceEventShortTermRental.maintenanceEventId, maintenanceEventShortTermRental.shortTermRentalId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.maintenanceEventShortTermRentals.splice(this.maintenanceEventShortTermRentals.indexOf(maintenanceEventShortTermRental), 1);
						this.recordTotal = this.maintenanceEventShortTermRentals.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'MaintenanceEventShortTermRental ' + maintenanceEventShortTermRental.shortTermRentalId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'MaintenanceEventShortTermRental ' + maintenanceEventShortTermRental.shortTermRentalId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add MaintenanceEventShortTermRental'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(MaintenanceEventShortTermRentalComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addMaintenanceEventShortTermRentalCB(data);
				// this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(maintenanceEventShortTermRental: MaintenanceEventShortTermRental) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			maintenanceEventShortTermRental: maintenanceEventShortTermRental,
			title: 'Edit MaintenanceEventShortTermRental'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(MaintenanceEventShortTermRentalComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateMaintenanceEventShortTermRentalCB(data);
				// this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteMaintenanceEventShortTermRentalCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addMaintenanceEventShortTermRentalCB(maintenanceEventShortTermRental: MaintenanceEventShortTermRental) {
		console.log('Adding MaintenanceEventShortTermRental: ' + JSON.stringify(maintenanceEventShortTermRental));
		// if we don't have a maintenanceEventShortTermRentals array yet...
		if (!this.maintenanceEventShortTermRentals) {
			this.maintenanceEventShortTermRentals = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.maintenanceEventShortTermRentals.unshift(maintenanceEventShortTermRental);

		// no idea what this is but it is required to update the array
		this.maintenanceEventShortTermRentals = [...this.maintenanceEventShortTermRentals];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MaintenanceEventShortTermRental ' + maintenanceEventShortTermRental.shortTermRentalId + ' Added', life: 3000 });
	}

	updateMaintenanceEventShortTermRentalCB(maintenanceEventShortTermRental: MaintenanceEventShortTermRental) {
		console.log('Updating MaintenanceEventShortTermRental: ' + JSON.stringify(maintenanceEventShortTermRental));
		let itemIndex = this.maintenanceEventShortTermRentals.findIndex((item: any) => (item.maintenanceEventId === maintenanceEventShortTermRental.maintenanceEventId && item.shortTermRentalId === maintenanceEventShortTermRental.shortTermRentalId));
		this.maintenanceEventShortTermRentals[itemIndex] = maintenanceEventShortTermRental;

		// no idea what this is but it is required to update the array
		this.maintenanceEventShortTermRentals = [...this.maintenanceEventShortTermRentals];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MaintenanceEventShortTermRental ' + maintenanceEventShortTermRental.shortTermRentalId + ' Updated', life: 3000 });
	}

	deleteMaintenanceEventShortTermRentalCB(maintenanceEventShortTermRental: MaintenanceEventShortTermRental) {
		console.log('Removing MaintenanceEventShortTermRental: ' + maintenanceEventShortTermRental);
		this.maintenanceEventShortTermRentals.splice(this.maintenanceEventShortTermRentals.indexOf(maintenanceEventShortTermRental), 1);
		this.recordTotal = this.maintenanceEventShortTermRentals.length;

		// no idea what this is but it is required to update the array
		this.maintenanceEventShortTermRentals = [...this.maintenanceEventShortTermRentals];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MaintenanceEventShortTermRental ' + maintenanceEventShortTermRental.shortTermRentalId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.maintenanceEventShortTermRentals ? this.first === (this.maintenanceEventShortTermRentals.length - this.rows) : true; }
	isFirstPage(): boolean { return this.maintenanceEventShortTermRentals ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(maintenanceEventShortTermRental: any) {
		if (maintenanceEventShortTermRental?.status) {
			const status = this.statuses.find((e: any) => e.value == maintenanceEventShortTermRental.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
}
